
// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import { getSiteRefrence } from "../../../api/endpoints/refrences";
// import { authSelector } from "../../../store/selectors/index";
// import "./style.css";

// // Reusable Table Section Component
// const StockTableSection = ({ title, data }) => (
//   <div>
//     <h2 className="text-lg font-semibold underline mb-4">{title}</h2>
//     <div className="overflow-x-auto">
//       <table className="w-full text-base text-left text-black border-collapse">
//         <thead className="bg-gray-100 text-black">
//           <tr>
//             <th className="border border-gray-300 px-3 py-2">Item Code</th>
//             <th className="border border-gray-300 px-3 py-2">Item Name</th>
//             <th className="border border-gray-300 px-3 py-2">Quantity</th>
//             <th className="border border-gray-300 px-3 py-2">Rate</th>
//             <th className="border border-gray-300 px-3 py-2">Amount</th>
//             <th className="border border-gray-300 px-3 py-2">Description</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.length === 0 ? (
//             <tr>
//               <td
//                 colSpan="6"
//                 className="text-center border border-gray-300 px-3 py-2"
//               >
//                 No Data
//               </td>
//             </tr>
//           ) : (
//             data.map((item, idx) => (
//               <tr key={idx} className="bg-white">
//                 <td className="border border-gray-300 px-3 py-2">{item.itemCode}</td>
//                 <td className="border border-gray-300 px-3 py-2">{item.itemName}</td>
//                 <td className="border border-gray-300 px-3 py-2">{item.quantity}</td>
//                 <td className="border border-gray-300 px-3 py-2">{item.rate}</td>
//                 <td className="border border-gray-300 px-3 py-2">{item.amount}</td>
//                 <td className="border border-gray-300 px-3 py-2">{item.itemDescription}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );


// // Main Component
// export const ComponentToPrint = React.forwardRef(
//   ({ item, startingDate, endingDate }, ref) => {
//     const { access_token } = useSelector(authSelector);

//     const [siteName, setSiteName] = useState();
//     const [siteAddress, setSiteAddress] = useState();
//     const [lastClosingStockAmount, setLastClosingStockAmount] = useState([]);
//     const [currentMonthPurchase, setCurrentMonthPurchase] = useState([]);
//     const [currentClosingStockAmount, setCurrentClosingStockAmount] = useState([]);
//     const [saleAmount, setSaleAmount] = useState([]);

//     useEffect(() => {
//       const lastClosing = [];
//       const currentPurchase = [];
//       const currentClosing = [];
//       const sale = [];

//       item.forEach((item) => {
//         if (item.printOrder === 1) lastClosing.push(item);
//         if (item.printOrder === 2) currentPurchase.push(item);
//         if (item.printOrder === 3) currentClosing.push(item);
//         if (item.printOrder === 4) sale.push(item);
//       });

//       setLastClosingStockAmount(lastClosing);
//       setCurrentMonthPurchase(currentPurchase);
//       setCurrentClosingStockAmount(currentClosing);
//       setSaleAmount(sale);
//     }, [item]);

//     const getName = async () => {
//       const result = await getSiteRefrence(access_token);
//       if (result.success) {
//         setSiteName(result.data.siteName);
//         setSiteAddress(result.data.siteAddress);
//       } else {
//         message.error(result.message);
//       }
//     };

//     useEffect(() => {
//       getName();
//     }, []);

//     const formatDate = (dateStr) => {
//       const date = new Date(dateStr);
//       return date.toLocaleDateString("en-GB");
//     };

//     return (
//       <div ref={ref}>
//         {/* Header */}
//         <div className="flex flex-col items-center justify-center mb-6 text-center">
//           <h1 className="text-2xl font-bold">{siteName}</h1>
//           <h2 className="text-md font-semibold">{siteAddress}</h2>
//           <h3 className="text-md mt-1">
//             From {formatDate(startingDate)} To {formatDate(endingDate)}
//           </h3>
//           <h3 className="text-md font-semibold mt-1">Stock Summary Rate Wise</h3>
//         </div>

//         {/* Tables */}
//         <div className="space-y-10">
//           <StockTableSection
//             title="Last Closing Stock"
//             data={lastClosingStockAmount}
//           />
//           <StockTableSection
//             title="Current Month Purchase"
//             data={currentMonthPurchase}
//           />
//           <StockTableSection
//             title="Current Closing Stock"
//             data={currentClosingStockAmount}
//           />
//           <StockTableSection title="Sale Amount" data={saleAmount} />
//         </div>
//       </div>
//     );
//   }
// );



// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import { getSiteRefrence } from "../../../api/endpoints/refrences";
// import { authSelector } from "../../../store/selectors/index";
// import "./style.css";

// const SummaryTable = ({ title, data }) => (
//   <div>
//     <h2 className="text-lg font-semibold underline mb-4">{title}</h2>
//     <div className="overflow-x-auto">
//       <table className="w-full text-base text-left text-black border-collapse">
//         <thead className="bg-gray-100 text-black">
//           <tr>
//             <th className="border px-3 py-2">Item Code</th>
//             <th className="border px-3 py-2">Item Name</th>
//             <th className="border px-3 py-2">LSTRate</th>
//             <th className="border px-3 py-2">PRate</th>
//             <th className="border px-3 py-2">CCSTRate</th>
//             <th className="border px-3 py-2">SRate</th>
//             <th className="border px-3 py-2">Cost</th>
//             <th className="border px-3 py-2">Sale</th>
//             <th className="border px-3 py-2">Gross</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.length === 0 ? (
//             <tr>
//               <td colSpan="9" className="text-center border px-3 py-2">
//                 No Data
//               </td>
//             </tr>
//           ) : (
//             data.map((item, idx) => (
//               <tr key={idx}>
//                 <td className="border px-3 py-2">{item.itemCode}</td>
//                 <td className="border px-3 py-2">{item.itemName}</td>
//                 <td className="border px-3 py-2">{item.lsRate}</td>
//                 <td className="border px-3 py-2">{item.pRate}</td>
//                 <td className="border px-3 py-2">{item.ccsRate}</td>
//                 <td className="border px-3 py-2">{item.sRate}</td>
//                 <td className="border px-3 py-2">{item.cost}</td>
//                 <td className="border px-3 py-2">{item.sale}</td>
//                 <td className="border px-3 py-2">{item.gross}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

// export const ComponentToPrint = React.forwardRef(({ item, startingDate, endingDate }, ref) => {
//   const { access_token } = useSelector(authSelector);
//   const [siteName, setSiteName] = useState();
//   const [siteAddress, setSiteAddress] = useState();
//   const [summaryData, setSummaryData] = useState([]);

//   const groupByItemCode = () => {
//     const grouped = {};

//     item.forEach((entry) => {
//       const code = entry.itemCode;
//       if (!grouped[code]) {
//         grouped[code] = {
//           itemCode: code,
//           itemName: entry.itemName,
//           lsAmount: 0,
//           pAmount: 0,
//           ccsAmount: 0,
//           sAmount: 0,
//           lsQty: 0,
//           pQty: 0,
//           ccsQty: 0,
//           sQty: 0
//         };
//       }

//       const group = grouped[code];
//       if (entry.printOrder === 1) {
//         group.lsAmount += entry.amount || 0;
//         group.lsQty += entry.quantity || 0;
//       }
//       if (entry.printOrder === 2) {
//         group.pAmount += entry.amount || 0;
//         group.pQty += entry.quantity || 0;
//       }
//       if (entry.printOrder === 3) {
//         group.ccsAmount += entry.amount || 0;
//         group.ccsQty += entry.quantity || 0;
//       }
//       if (entry.printOrder === 4) {
//         group.sAmount += entry.amount || 0;
//         group.sQty += entry.quantity || 0;
//       }
//     });

//     const summary = Object.values(grouped).map((item) => {
//       const cost = item.lsAmount + item.pAmount - item.ccsAmount;
//       const sale = item.sAmount;
//       const gross = sale - cost;


//       return {
//         itemCode: item.itemCode,
//         itemName: item.itemName,
//         lsRate: (item.lsAmount / item.lsQty || 0).toFixed(2),
//         pRate: (item.pAmount / item.pQty || 0).toFixed(2),
//         ccsRate: (item.ccsAmount / item.ccsQty || 0).toFixed(2),
//         sRate: (item.sAmount / item.sQty || 0).toFixed(2),
//         cost: cost,
//         sale: sale,
//         gross: gross
//       };
//     });

//     setSummaryData(summary);
//   };

//   const getName = async () => {
//     const result = await getSiteRefrence(access_token);
//     if (result.success) {
//       setSiteName(result.data.siteName);
//       setSiteAddress(result.data.siteAddress);
//     } else {
//       message.error(result.message);
//     }
//   };

//   useEffect(() => {
//     getName();
//     groupByItemCode();
//   }, [item]);

//   const formatDate = (dateStr) => {
//     const date = new Date(dateStr);
//     return date.toLocaleDateString("en-GB");
//   };

//   return (
//     <div ref={ref}>
//       <div className="flex flex-col items-center justify-center mb-6 text-center">
//         <h1 className="text-2xl font-bold">{siteName}</h1>
//         <h2 className="text-md font-semibold">{siteAddress}</h2>
//         <h3 className="text-md mt-1">From {formatDate(startingDate)} To {formatDate(endingDate)}</h3>
//         <h3 className="text-md font-semibold mt-1">Stock Summary Rate Wise</h3>
//       </div>

//       <div className="space-y-10">
//         <SummaryTable title="Summary By Item Code" data={summaryData} />
//       </div>
//     </div>
//   );
// });


// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import { getSiteRefrence } from "../../../api/endpoints/refrences";
// import { authSelector } from "../../../store/selectors/index";
// import "./style.css";

// const SummaryTable = ({ title, data }) => (
//   <div>
//     <h2 className="text-lg font-semibold underline mb-4">{title}</h2>
//     <div className="overflow-x-auto">
//       <table className="w-full text-base text-left text-black border-collapse">
//         <thead className="bg-gray-100 text-black">
//           <tr>
//             <th className="border px-3 py-2">Item Code</th>
//             <th className="border px-3 py-2">Item Name</th>
//             <th className="border px-3 py-2">Cost</th>
//             <th className="border px-3 py-2">Sale</th>
//             <th className="border px-3 py-2">Gross</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.length === 0 ? (
//             <tr>
//               <td colSpan="5" className="text-center border px-3 py-2">
//                 No Data
//               </td>
//             </tr>
//           ) : (
//             data.map((item, idx) => (
//               <tr key={idx}>
//                 <td className="border px-3 py-2">{item.itemCode}</td>
//                 <td className="border px-3 py-2">{item.itemName}</td>
//                 <td className="border px-3 py-2">{item.cost.toFixed(2)}</td>
//                 <td className="border px-3 py-2">{item.sale.toFixed(2)}</td>
//                 <td className="border px-3 py-2">{item.gross.toFixed(2)}</td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

// export const ComponentToPrint = React.forwardRef(({ item, startingDate, endingDate }, ref) => {
//   const { access_token } = useSelector(authSelector);
//   const [siteName, setSiteName] = useState();
//   const [siteAddress, setSiteAddress] = useState();
//   const [summaryData, setSummaryData] = useState([]);

//   const groupByItemCode = () => {
//     const grouped = {};

//     item.forEach((entry) => {
//       const code = entry.itemCode;
//       if (!grouped[code]) {
//         grouped[code] = {
//           itemCode: code,
//           itemName: entry.itemName,
//           lsAmount: 0,
//           pAmount: 0,
//           ccsAmount: 0,
//           sAmount: 0
//         };
//       }

//       const group = grouped[code];

//       const amount = Number(entry.amount) || 0;

//       if (entry.printOrder === 1) group.lsAmount += amount;
//       if (entry.printOrder === 2) group.pAmount += amount;
//       if (entry.printOrder === 3) group.ccsAmount += amount;
//       if (entry.printOrder === 4) group.sAmount += amount;
//     });

//     const summary = Object.values(grouped).map((item) => {
//       const cost = (item.lsAmount || 0) + (item.pAmount || 0) - (item.ccsAmount || 0);
//       const sale = item.sAmount || 0;
//       const gross = sale - cost;

//       return {
//         itemCode: item.itemCode,
//         itemName: item.itemName,
//         cost,
//         sale,
//         gross
//       };
//     });

//     setSummaryData(summary);
//   };

//   const getName = async () => {
//     const result = await getSiteRefrence(access_token);
//     if (result.success) {
//       setSiteName(result.data.siteName);
//       setSiteAddress(result.data.siteAddress);
//     } else {
//       message.error(result.message);
//     }
//   };

//   useEffect(() => {
//     getName();
//     groupByItemCode();
//   }, [item]);

//   const formatDate = (dateStr) => {
//     const date = new Date(dateStr);
//     return date.toLocaleDateString("en-GB");
//   };

//   return (
//     <div ref={ref}>
//       <div className="flex flex-col items-center justify-center mb-6 text-center">
//         <h1 className="text-2xl font-bold">{siteName}</h1>
//         <h2 className="text-md font-semibold">{siteAddress}</h2>
//         <h3 className="text-md mt-1">From {formatDate(startingDate)} To {formatDate(endingDate)}</h3>
//         <h3 className="text-md font-semibold mt-1">Stock Summary Rate Wise</h3>
//       </div>

//       <div className="space-y-10">
//         <SummaryTable title="Summary By Item Code" data={summaryData} />
//       </div>
//     </div>
//   );
// });

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { message } from "antd";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import "./style.css";

const SummaryTable = ({ title, data }) => {
  const filteredData = data.filter(item => item.itemCode > 3);

  const total = filteredData.reduce(
    (acc, curr) => {
      acc.cost += curr.cost;
      acc.sale += curr.sale;
      acc.gross += curr.gross;
      return acc;
    },
    { cost: 0, sale: 0, gross: 0 }
  );

  return (
    <div>
      {/* <h2 className="text-lg font-semibold underline mb-4">{title}</h2> */}
      <div className="overflow-x-auto">
        <table className="w-full text-base text-left text-black border-collapse">
          <thead className="bg-gray-100 text-black">
            <tr>
              <th className="border px-3 py-2">Item Code</th>
              <th className="border px-3 py-2">Item Name</th>            
              <th className="border px-3 py-2">PRate</th>
              <th className="border px-3 py-2">SRate</th>
              <th className="border px-3 py-2">Cost</th>
              <th className="border px-3 py-2">Sale</th>
              <th className="border px-3 py-2">Gross</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center border px-3 py-2">No Data</td>
              </tr>
            ) : (
              <>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td className="border px-3 py-2">{item.itemCode}</td>
                    <td className="border px-3 py-2">{item.itemName}</td>
                    <td className="border px-3 py-2">{item.ccsRate.toFixed(2)}</td>
                    <td className="border px-3 py-2">{item.sRate.toFixed(2)}</td>
                    <td className="border px-3 py-2">{item.cost.toFixed(2)}</td>
                    <td className="border px-3 py-2">{item.sale.toFixed(2)}</td>
                    <td className="border px-3 py-2">{item.gross.toFixed(2)}</td>
                  </tr>
                ))}

                {/* Total row */}
                <tr className="font-semibold bg-gray-100">
                  <td colSpan="4" className="border px-3 py-2 text-right">Total:</td>
                  <td className="border px-3 py-2">{total.cost.toFixed(2)}</td>
                  <td className="border px-3 py-2">{total.sale.toFixed(2)}</td>
                  <td className="border px-3 py-2">{total.gross.toFixed(2)}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};


export const ComponentToPrint = React.forwardRef(({ item, startingDate, endingDate }, ref) => {
  const { access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [summaryData, setSummaryData] = useState([]);

  const groupByItemCode = () => {
    const grouped = {};

    item.forEach((entry) => {
      const code = entry.itemCode;
      if (!grouped[code]) {
        grouped[code] = {
          itemCode: code,
          itemName: entry.itemName,
          lsAmount: 0,
          pAmount: 0,
          ccsAmount: 0,
          sAmount: 0,
          lsQty: 0,
          pQty: 0,
          ccsQty: 0,
          sQty: 0,
        };
      }

      const amount = Number(entry.amount) || 0;
      const quantity = Number(entry.quantity) || 0;
      const group = grouped[code];

      if (entry.printOrder === 1) {
        group.lsAmount += amount;
        group.lsQty += quantity;
      }
      if (entry.printOrder === 2) {
        group.pAmount += amount;
        group.pQty += quantity;
      }
      if (entry.printOrder === 3) {
        group.ccsAmount += amount;
        group.ccsQty += quantity;
      }
      if (entry.printOrder === 4) {
        group.sAmount += amount;
        group.sQty += quantity;
      }
    });

    const summary = Object.values(grouped)
      .map((item) => {
        const cost = item.lsAmount + item.pAmount - item.ccsAmount;
        const sale = item.sAmount;
        const gross = sale - cost;

        return {
          itemCode: item.itemCode,
          itemName: item.itemName,
          cost,
          sale,
          gross,
          lsRate: item.lsQty ? item.lsAmount / item.lsQty : 0,
          pRate: item.pQty ? item.pAmount / item.pQty : 0,
          ccsRate: item.ccsQty ? item.ccsAmount / item.ccsQty : 0,
          sRate: item.sQty ? item.sAmount / item.sQty : 0,
        };
      })
      .filter((item) => item.cost !== 0 || item.sale !== 0);

    setSummaryData(summary);
  };

  const getName = async () => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  useEffect(() => {
    getName();
    groupByItemCode();
  }, [item]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB");
  };

  return (
    <div ref={ref}>
      <div className="flex flex-col items-center justify-center mb-6 text-center">
        <h1 className="text-2xl font-bold">{siteName}</h1>
        <h2 className="text-md font-semibold">{siteAddress}</h2>
        <h3 className="text-md mt-1">
          From {formatDate(startingDate)} To {formatDate(endingDate)}
        </h3>
        <h3 className="text-md font-semibold mt-1">
          Stock Summary Rate Wise
        </h3>
      </div>

      <div className="space-y-10">
        <SummaryTable title="Summary By Item Code" data={summaryData} />
      </div>
    </div>
  );
});


